module.exports = __webpack_public_path__ + "/6dfc242ce6ea82216552d32683a6f616.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/images/customers/logos/Samsung_Logo.svg.png
 ** module id = 1181
 ** module chunks = 0
 **/